export const PRODUCTS_REPORT = 'PRODUCTS_REPORT';
export const ORDERS_REPORT = 'ORDERS_REPORT';
export const CUSTOMERS_REPORT = 'CUSTOMERS_REPORT';
export const SALES_REPORT = 'SALES_REPORT';
export const TOP_SELLERS = 'TOP_SELLERS';
